import {FreeTrialProgram, relevantFreePickupSoccerAndLeaguesUrlParams} from '@/common/fko-utils';
import {
  getFreePickupAndLeaguesFormDataForSubmission,
  getFreePickupAndLeaguesFormFields,
} from '@/common/freePickupandLeaguesUtils';
import CommonRegistrationPage from '@/components/Forms/CommonRegistrationForm/CommonRegistrationPage';
import {tocaLocations, tocaLocationsWithoutWorkingMboSiteId} from '@/constants/locations';
import {memo} from 'react';

const locationsAllowed = [...tocaLocations, ...tocaLocationsWithoutWorkingMboSiteId]
  .filter((loc) => loc.pickupSoccerSupported)
  .map((loc) => loc.hubspotName);

const FreePickupSoccerRegistrationPage = memo(() => {
  return (
    <CommonRegistrationPage
      programName={FreeTrialProgram.PICKUP_SOCCER}
      locationsAllowed={locationsAllowed}
      formId={import.meta.env.VITE_HUBSPOT_FREE_PICKUP_SOCCER_FORM_ID ?? ''}
      relevantUrlParams={relevantFreePickupSoccerAndLeaguesUrlParams}
      getFormFields={getFreePickupAndLeaguesFormFields}
      getHubspotFormDataForSubmission={getFreePickupAndLeaguesFormDataForSubmission}
    />
  );
});

FreePickupSoccerRegistrationPage.displayName = 'FreePickupSoccerRegistrationPage';

export default FreePickupSoccerRegistrationPage;
